import { pluralizeBanks } from './pluralizeBanks';

export const getEsiaExactTermsBenefit = (bankName: string, mplCount: number) => {
  if (mplCount <= 1) {
    return `Узнаете точные условия в ${bankName}`;
  }

  const restCount = mplCount - 1;

  return `Узнаете точные условия в ${bankName} и ещё в ${restCount} ${pluralizeBanks(restCount)}`;
};
